import { IconButton, InputAdornment, OutlinedInput, useTheme } from "@mui/material";
import useSession from "hooks/call-queue/useSession";
import useApi from "hooks/useApi";
import useFirebase from "hooks/useFirebase";
import { Send } from "iconsax-react";
import { useState } from "react";

const ChatInput = () => {
    const theme = useTheme();
    const { user } = useApi();
    const { pushMessage } = useFirebase();
    const { session } = useSession();
    const [fieldValue, setFieldValue] = useState('');

    const submitMessage = () => {
        let message = fieldValue;

        let payload = {
            fromName: `${user?.firstName} ${user?.lastName}`,
            uid: user.uid,
            message,
            createdAt: new Date().getTime(),
            readBy: [ user.uid ]
        }
        if(message){
            pushMessage(session?.transaction!, payload);
            setFieldValue('');
        }
    }
    
    return (
        <OutlinedInput
            id="chat-input"
            name='message'
            defaultValue={fieldValue}
            value={fieldValue}
            onChange={(e) => {
                setFieldValue(e.target.value);
            }}
            onKeyDown={(e) => {
                if (e.key === "Enter") {
                    e.preventDefault();
                    submitMessage();
                }
            }}
            endAdornment={
                <InputAdornment position="end" sx={{ mr: -0.5 }}>
                    <IconButton type="button" onClick={submitMessage} sx={{ borderRadius: '50%' }}>
                        <Send size={16} color={theme.palette.primary.main} />
                    </IconButton>
                </InputAdornment>
            }
            aria-describedby="header-search-text"
            inputProps={{
                'aria-label': 'weight'
            }}
            placeholder="Type a message"
            fullWidth
            sx={{ '& .MuiOutlinedInput-input': { p: 1.5 }, pr: 1, borderRadius: '30px', background: '#fff' }}
        />
    )
}

export default ChatInput;